module.exports = __webpack_public_path__ + "img/ic_ziel.edccb17d.svg";